import colors from "common/theme/foundations/colors";
import { useState, useEffect, useRef } from "react";

const colorsCode = [
  { hex: colors.shadeRed, name: "Red" },
  { hex: colors.shadeGreen, name: "Green" },
  { hex: colors.shadeYellow, name: "Yellow" },
  { hex: colors.shadeOrange, name: "Orange" },
  { hex: colors.shadeBlue, name: "Blue" },
  { hex: colors.shadeVoilet, name: "Voilet" },
  { hex: colors.shadePurple, name: "Purple" },
  { hex: colors.shadeBlack, name: "Black" },
  { hex: colors.shadeWhite, name: "White" },
  { hex: colors.shadeGrey, name: "Grey" },
];

const ColorPicker = ({ onSelect, value, name, onBlur, errors, touched, disabled }) => {
  const [active, setActive] = useState(false);
  const [selectedColor, setSelectedColor] = useState(null);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const color = colorsCode.find((c) => c.hex === value);
    setSelectedColor(color || null);
  }, [value]);

  const handleSelect = (color) => {
    setSelectedColor(color);
    setActive(false);
    if (onSelect) onSelect({ target: { name, value: color.hex } });
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setActive(false);
    }
  };

  useEffect(() => {
    if (active) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [active]);

  return (
    <div ref={dropdownRef} id="color-picker" className="wrapper-dropdown relative">
      <span
        className={`colorSpan ${disabled ? "pointerNone customDisable" : ""} ${
          errors?.[name] && touched?.[name] ? "border-red-300" : "border-gray-400"
        }`}
        onClick={() => setActive(!active)}
      >
        {selectedColor ? (
          <span className="selectedColorBox">
            <span
              className="selectedColor"
              style={{ backgroundColor: selectedColor.hex }}
            ></span>
            {selectedColor.name}
          </span>
        ) : (
          "Select Color"
        )}
      </span>
      {active && (
        <ul className="dropdown absolute w-full mt-1 border bg-white shadow-lg z-10">
          {colorsCode.map((color) => (
            <li
              key={color.hex}
              className="p-2 flex items-center cursor-pointer hover:bg-gray-100"
              onClick={() => handleSelect(color)}
            >
              <span
                className="colorBox w-5 h-5 inline-block mr-2"
                style={{ backgroundColor: color.hex }}
              ></span>
              {color.name}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default ColorPicker;
